export default __webpack_public_path__ + "static/media/tl-macroeconomics.0253cfa3.png";